import jQuery from "jquery";
const $ = jQuery; // ドルマークに参照を代入(慣習的な $ を使うため)

/*
 * Featherlight // $ npm i featherlight
 */
import featherlight from "featherlight";
$("[data-featherlight]").featherlight();

/*
 * Swiper
 */

import Swiper from "swiper";
import { Navigation, Pagination, EffectFade, Autoplay } from "swiper/modules";

// Single
const postSwiper = new Swiper(".post-swiper", {
  slidesPerView: 1,
  spaceBetween: 18,
  centeredSlides: false,
  /*
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  */
  breakpoints: {
    768: {
      slidesPerView: 3,
      spaceBetween: 48,
      initialSlide: 1,
      centeredSlides: true,
    },
  },
});

// Hero
const heroSwiper = new Swiper(".hero-swiper", {
  modules: [Pagination, EffectFade, Autoplay],
  loop: true,
  effect: "fade",
  fadeEffect: {
    crossFade: true,
  },
  speed: 1000,
  pagination: {
    el: ".swiper-pagination",
    type: "bullets",
  },
  autoplay: {
    delay: 3800,
    disableOnInteraction: false,
  },
});

// Banners swiper
const bannersSwiper = new Swiper(".banners-swiper", {
  modules: [Pagination, Navigation, Autoplay],
  slidesPerView: 1,
  spaceBetween: 15,
  centeredSlides: false,
  autoplay: {
    delay: 3000,
  },
  pagination: {
    el: ".swiper-pagination",
    type: "bullets",
  },
  breakpoints: {
    768: {
      slidesPerView: 2,
      spaceBetween: 30,
      centeredSlides: false,
    },
  },
});

/*
 * Single product
 */
let SingleProductSwiper; // 再初期化用に保持
const breakpoint = window.matchMedia("(max-width: 575px)");

function enableSingleProductSwiper() {
  if (!SingleProductSwiper) {
    SingleProductSwiper = new Swiper(".product-gallery-swiper", {
      modules: [Pagination, Navigation],
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
      },
      spaceBetween: 10,
      slidesPerView: 1,
    });
  }
}

function destroySingleProductSwiper() {
  if (SingleProductSwiper) {
    SingleProductSwiper.destroy(true, true); // インスタンスとstyleを削除
    SingleProductSwiper = null;
  }
}

function checkBreakpoint() {
  if (breakpoint.matches) {
    enableSingleProductSwiper(); // 575px以下 → Swiper有効
  } else {
    destroySingleProductSwiper(); // 578px以上 → Swiper無効
  }
}

breakpoint.addEventListener("change", checkBreakpoint);
document.addEventListener("DOMContentLoaded", checkBreakpoint);

/*
 * IntersectionObserver - Scroll Color Changer
 */

document.addEventListener("DOMContentLoaded", function () {
  const targets = document.querySelectorAll("[data-bg][data-color]");
  const root = document.documentElement;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const el = entry.target;
        const bg = el.dataset.bg;
        const color = el.dataset.color;

        if (entry.isIntersecting) {
          // 表示エリアに入ったら適用
          root.style.setProperty("--body-bg", bg);
          root.style.setProperty("--body-color", color);
        } else {
          // 表示エリアから出たらリセット（空またはデフォルト値）
          root.style.removeProperty("--body-bg");
          root.style.removeProperty("--body-color");
        }
      });
    },
    {
      threshold: 0, // 1pxでも入ったら発火（下で調整）
      rootMargin: "0px 0px -75% 0px",
    },
  );

  targets.forEach((el) => observer.observe(el));
});

/* ----------------------------------------
 * Custom
 * -------------------------------------- */

//
/* :root --container-x-gap */
(function () {
  let lastWidth = window.innerWidth;

  function updateContainerXGap() {
    const container = document.querySelector(".container");

    if (!container) {
      const bsGutter =
        getComputedStyle(document.documentElement).getPropertyValue(
          "--bs-gutter-x",
        ) || "0px";
      document.documentElement.style.setProperty("--container-x-gap", bsGutter);
      return;
    }

    const containerRect = container.getBoundingClientRect();
    const style = getComputedStyle(container);
    const paddingLeft = parseFloat(style.paddingLeft) || 0;

    const windowWidth = window.innerWidth;
    const containerWidth = containerRect.width;
    const gap = (windowWidth - containerWidth) / 2 + paddingLeft;

    document.documentElement.style.setProperty("--container-x-gap", `${gap}px`);
  }

  window.addEventListener("DOMContentLoaded", updateContainerXGap);

  let resizeTimer;
  window.addEventListener("resize", () => {
    const currentWidth = window.innerWidth;

    // 高さだけの変化は無視
    if (currentWidth === lastWidth) return;

    lastWidth = currentWidth;

    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateContainerXGap, 100);
  });
})();

// event swiper
const eventSwiper = new Swiper(".event-swiper", {
  slidesPerView: 2,
  spaceBetween: 18,
  centeredSlides: false,
  breakpoints: {
    768: {
      slidesPerView: 5,
      spaceBetween: 48,
      initialSlide: 1,
      centeredSlides: false,
    },
  },
});

// screen single swiper（上映・イベント詳細の画像）
const screenSingleSwiper = new Swiper(".screen-single-swiper", {
  modules: [Pagination],
  slidesPerView: "auto",
  spaceBetween: 18,

  centeredSlides: true,
  // centerInsufficientSlides: true,
  watchOverflow: true,
  // ★ 1枚のときは loop を無効化
  // loop: document.querySelectorAll('.screen-single-swiper .swiper-slide').length > 1,

  loop: true,
  pagination: {
    el: ".swiper-pagination",
    type: "bullets",
  },
  breakpoints: {
    768: {
      slidesPerView: "auto",
      spaceBetween: 48,
    },
  },
});

/**
 * 上映日時（pa_showtime）だけ、セレクトの代わりに日付ごとのリストを描画
 */
document.addEventListener("click", function (e) {
  const a = e.target.closest(".wc-showtime-list .showtime-item");
  if (!a) return;

  e.preventDefault();
  if (
    a.classList.contains("is-disabled") ||
    a.getAttribute("aria-disabled") === "true"
  )
    return;

  const wrap = a.closest(".wc-showtime-list");
  const form = a.closest("form.variations_form");
  if (!form) {
    console.warn("[showtime] variations_form が見つかりません");
    return;
  }

  // 1) data-target-select があればそれを優先
  let select = null;
  const selectName = wrap?.dataset?.targetSelect;
  if (selectName) {
    select = form.querySelector(`select[name="${CSS.escape(selectName)}"]`);
  }

  // 2) 見つからなければ自動検出（attribute_pa_showtime 系）
  if (!select) {
    select = form.querySelector('select[name^="attribute_pa_showtime"]');
  }

  if (!select) {
    console.error(
      '[showtime] 対応する <select name="attribute_pa_showtime"> が見つかりません',
    );
    return;
  }

  // UIの選択状態を更新
  wrap
    .querySelectorAll(".showtime-item.is-active")
    .forEach((el) => el.classList.remove("is-active"));
  a.classList.add("is-active");

  // 値をセット（data-value は term の slug と一致している必要あり）
  const val = a.dataset.value || "";
  select.value = val;

  // Woo のバリエーション判定を走らせる
  select.dispatchEvent(new Event("change", { bubbles: true }));
});

// プリセット（?attribute_pa_showtime=...）対応はそのままでOK
document.addEventListener("DOMContentLoaded", function () {
  const form = document.querySelector("form.variations_form");
  if (!form) return;

  jQuery(form).on(
    "woocommerce_variation_has_changed found_variation reset_data show_variation",
    function () {
      const marker = document.querySelector(".js-preselect-showtime");
      if (!marker) return;
      const attr = marker.dataset.attr;
      const val = marker.dataset.value;
      if (!attr || !val) return;

      const select =
        form.querySelector(`select[name="${CSS.escape(attr)}"]`) ||
        form.querySelector('select[name^="attribute_pa_showtime"]');
      const uiList = form.querySelector(".wc-showtime-list");

      if (select) {
        select.value = val;
        select.dispatchEvent(new Event("change", { bubbles: true }));
        if (uiList) {
          uiList
            .querySelectorAll(".showtime-item.is-active")
            .forEach((el) => el.classList.remove("is-active"));
          const hit = uiList.querySelector(
            `.showtime-item[data-value="${CSS.escape(val)}"]`,
          );
          if (hit) hit.classList.add("is-active");
        }
        marker.remove();
      }
    },
  );
});

// 1) 「バリエーションをクリア」時にUIもクリア
// Woo標準の「クリア」操作（.reset_variations クリック）で、アクティブ表示を外します。
document.addEventListener(
  "click",
  function (e) {
    const resetBtn = e.target.closest(".variations_form .reset_variations");
    if (!resetBtn) return;
    const form = resetBtn.closest("form.variations_form");
    const list = form?.querySelector(".wc-showtime-list");
    if (list)
      list
        .querySelectorAll(".showtime-item.is-active")
        .forEach((el) => el.classList.remove("is-active"));
  },
  true,
);

// 2) セレクトを直接変更した場合もUIに反映
// （キーボード操作や別スクリプトで <select> の値が変わった場合の見た目同期）
document.addEventListener("change", function (e) {
  const select = e.target.closest(
    'form.variations_form select[name^="attribute_pa_showtime"]',
  );
  if (!select) return;
  const form = select.closest("form.variations_form");
  const list = form?.querySelector(".wc-showtime-list");
  if (!list) return;
  list
    .querySelectorAll(".showtime-item.is-active")
    .forEach((el) => el.classList.remove("is-active"));
  const hit =
    select.value &&
    list.querySelector(
      `.showtime-item[data-value="${CSS.escape(select.value)}"]`,
    );
  if (hit) hit.classList.add("is-active");
});
